import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  deselectOwnershipOption,
  isOwnershipOptionSelected,
  selectOwnershipOption,
} from "reduxSlices/reportIndexSlice"
import { Checkbox } from "shared/checkboxes"
import { SidebarContentItem } from "shared/Sidebar"

const ReportIndexSidebarOwnershipSectionOwnershipCheckbox = ({ label, option }) => {
  const dispatch = useDispatch()

  const optionIsSelected = useSelector(isOwnershipOptionSelected(option))

  const toggleReducer = optionIsSelected ? deselectOwnershipOption : selectOwnershipOption

  const toggleSelection = () => dispatch(toggleReducer({ option }))

  return (
    <SidebarContentItem onClickCapture={toggleSelection}>
      <div className="flex justify-between">
        <span>{label}</span>
        <Checkbox onChange={toggleSelection} value={optionIsSelected} />
      </div>
    </SidebarContentItem>
  )
}

ReportIndexSidebarOwnershipSectionOwnershipCheckbox.propTypes = {
  label: types.string.isRequired,
  option: types.string.isRequired,
}

export default ReportIndexSidebarOwnershipSectionOwnershipCheckbox
